import api from "actions/api.js"


export function getCitizenships(personid) {
    return api(`profile/${personid}/citizenship`)
}

export function postCitizenship(record) {
    const { personid, citizenship } = record

    return api("personcitizenship",
        {
            method: "POST",
            body: JSON.stringify({
                personid, citizenship
            })
        })
}

export function deleteCitizenship(id) {
    return api(`personcitizenship/${id}`,
        {
            method: "DELETE"
        })
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/citizenship/api.js
 **/